import axios, { AxiosRequestConfig } from 'axios';

import { ILocalDocument } from '../../../types/Document';
import axiosInterceptor from '../../utils/axios';
import { fileChecksum } from '../../utils/fileChecksum';
import { ConfigIProps } from './ordersTypes';

export const beginUploadDocuments = (
  id: string | undefined,
  documentNamesArray: string[],
  documentDataArray: ILocalDocument[],
  config: ConfigIProps
) => {
  return new Promise((resolve, reject) => {
    (async function () {
      const url = config.baseURL + '/order-management/presigned-url';
      const md5Array: string[] = [];

      for (let i = 0; i < documentDataArray.length; i++) {
        const hex: any = await fileChecksum(documentDataArray[i].File);
        md5Array.push(hex);
      }
      const payload = {
        OrderId: id,
        ObjectKeysCsv: documentNamesArray.join(),
        ObjectHashes: md5Array.join(),
      };
      axiosInterceptor
        .get(url, { params: payload })
        .then((response) => {
          resolve({
            signedUrls: response.data.SignedUrls,
            documents: documentDataArray,
            md5Array: md5Array,
          });
        })
        .catch((error) => {
          reject(
            error?.response?.data?.Message
              ? error.response.data.Message
              : error.message
          );
        });
    })();
  });
};

export const uploadFileToS3 = (
  url: string,
  file: ILocalDocument['File'],
  md5: string
) => {
  return new Promise((resolve, reject) => {
    const axiosConfig: AxiosRequestConfig = {
      method: 'PUT',
      url: url,
      headers: {
        'Content-MD5': md5,
        'Content-Type': 'application/pdf',
      },
      data: file,
    };
    axios(axiosConfig)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadFileToSolex = (
  id: string,
  solexSessionId: string,
  file: any,
  config: ConfigIProps
) => {
  return new Promise((resolve, reject) => {
    const url = config.baseURL + '/order-management/upload-solex-document';
    const payload = {
      OrderId: id,
      SolexSessionId: solexSessionId,
      Document: file,
    };
    axiosInterceptor
      .post(url, payload)
      .then(() => {
        resolve({ message: 'Your file has been successfully uploaded' });
      })
      .catch((error) => {
        reject(
          error?.response?.data?.Message
            ? error.response.data.Message
            : error.message
        );
      });
  });
};
